import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { AuthService } from "../../infrastructure/auth.service";
import { ErrorsService } from "common";

@Injectable({
  providedIn: "root",
})
export class CallbackGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
    private errorsService: ErrorsService
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    this.authService.handleCallback().subscribe((res) => {
      if (res) {
        this.handleRedirect();
        return;
      }

      this.errorsService.showGeneralErrorPage();
    });

    return false;
  }

  private handleRedirect() {
    const historyQuery = sessionStorage.getItem("navigation.historyQuery");
    const history = sessionStorage.getItem("navigation.history");
    let navigateTo = "home";

    if (this.isUsableTarget(historyQuery)) {
      navigateTo = historyQuery;
    } else if (this.isUsableTarget(history)) {
      navigateTo = history;
    }

    sessionStorage.removeItem("navigation.historyQuery");
    sessionStorage.removeItem("navigation.history");
    this.router.navigateByUrl(navigateTo, { replaceUrl: true });
  }

  // A stored history entry is only a usable post-login destination when it points at a real
  // page. The root path ("/", "/?") and the auth-flow routes just bounce back through the
  // sign-in redirect (and, while authenticated, the LoginGuard's navigate-to-dashboard is
  // dropped because it fires during this navigation's cancellation), leaving the app stuck on
  // a blank "/". Fall back to "home" (→ dashboard) for those.
  private isUsableTarget(target: string | null): boolean {
    if (!target) {
      return false;
    }
    const path = target.split(/[?#]/)[0].replace(/\/+$/, "");
    if (path === "") {
      return false;
    }
    const excludedPaths = ["sign-in", "login", "callback", "sign-out", "error"];
    return !excludedPaths.some((excluded) => path.includes(excluded));
  }
}
